import scheduler from '@/launcher/services/scheduler';
import stackDebounce from 'stack-debounce';
import Deferred from 'defer-promise';
import { isEqual, get } from 'lodash-es';
import * as workerTimers from 'worker-timers';
import { generateUUID } from '@/core/shared/helpers/VariousHelper';

export default {
  async created () {
    scheduler.on('init', () => {
      this.setupSessionWatcher();
    });
  },
  destroyed () {
    if (this.pollingInterval !== undefined) workerTimers.clearInterval(this.pollingInterval);
  },
  methods: {
    setupSessionWatcher () {
      const watcherHandler = async (newSessionData) => {
        const previousSession = this.$store.state.launcher.previousSession;
        if (previousSession !== null) {
          const { startTime, endTime, id, ...currentSessionData } = previousSession;
          if (isEqual(newSessionData, currentSessionData)) return;
        }
        this.sessionToken = generateUUID();
        this.updateCurrentSessionEveryMin(this.sessionToken);
        return this.newGameSession(newSessionData, previousSession);
      };
      // Here we queue next call to ensure a previous session id has return from the server and we debounce by second
      const debouncedHandler = stackDebounce(watcherHandler, (promise) => {
        if (!promise) return Promise.resolve();
        const defer = Deferred();
        scheduler.once('tick', () => defer.resolve());
        return Promise.all([
          promise,
          defer.promise,
        ]);
      });
      this.$store.watch((state, getters) => {
        get(state.launcher, 'previousSession'); // track previousSession
        get(getters, 'safetyMode'); // track safety mode
        return getters.sessionData;
      }, (to, from) => {
        if (!to) return;
        if (!isEqual(to, from) || !this.$store.state.launcher.previousSession) { // since session data is derived from currentBooking (for the customer) it is computed every seconds we need to diff data to prevent server spam
          debouncedHandler(to);
        }
      }, { immediate: true });
    },
    async newGameSession (newSessionData, previousSessionData) {
      const nowTime = this.getCurrentTime();
      const newSession = {
        ...newSessionData,
        startTime: nowTime,
      };
      if (!previousSessionData) {
        this.$store.commit('setPreviousImpulseTime', nowTime);
        return this.$store.dispatch('storeGameSessions', newSession);
      } else {
        const prevSession = {
          endTime: nowTime,
          id: previousSessionData.id,
        };
        return this.$store.dispatch('storeGameSessions', [prevSession, newSession]);
      }
    },
    async updateGameSession (token) {
      const session = this.$store.state.launcher.previousSession;
      if (!session || token !== this.sessionToken) return;
      const nowTime = this.getCurrentTime();
      const currentSession = {
        endTime: nowTime,
        id: session.id,
      };
      return this.$store.dispatch('storeGameSessions', currentSession);
    },
    updateCurrentSessionEveryMin (token) {
      // reset previous polling
      if (this.pollingInterval !== undefined) workerTimers.clearInterval(this.pollingInterval);
      this.pollingInterval = workerTimers.setInterval(() => {
        this.updateGameSession(token);
      }, 60000);
    },
    getCurrentTime () {
      const time = scheduler.stopStopwatch();
      scheduler.startStopwatch();
      return time;
    },
  },
};
